const debounce = require('lodash/debounce');

function followAndShareWidgetPosition() {
    const widgetDropdownEL = $('.widget.dropdown');

    if (widgetDropdownEL) {
        widgetDropdownEL.each(function (i) {
            if (widgetDropdownEL[i].classList.contains("ignore-placement-fix")) {
                return;
            }

            const widgetEl = $(this);

            const widgetOffsetLeft = widgetEl.offset().left;
            const widgetOffsetRight = $('body').innerWidth() - widgetEl.width() - widgetEl.offset().left;
            const widgetMenuWidth = 300;
            const offset = 5;
            const widgetCaretPosition = widgetMenuWidth / 2 - offset;

            const widgetMenuEl = widgetEl.find('.widget-menu');

            if (widgetOffsetLeft > widgetCaretPosition && widgetOffsetRight > widgetCaretPosition) {
                widgetMenuEl.removeClass('widget-menu-left widget-menu-center widget-menu-right');
                widgetMenuEl.addClass('widget-menu-center');
            }
            else if (
                widgetOffsetLeft > widgetCaretPosition &&
                widgetOffsetRight < widgetCaretPosition
            ) {
                widgetMenuEl.removeClass('widget-menu-left widget-menu-center widget-menu-right');
                widgetMenuEl.addClass('widget-menu-left');
            }
            else if (
                widgetOffsetLeft < widgetCaretPosition &&
                widgetOffsetRight > widgetCaretPosition
            ) {
                widgetMenuEl.removeClass('widget-menu-left widget-menu-center widget-menu-right');
                widgetMenuEl.addClass('widget-menu-right');
            }
        });
    }
}

followAndShareWidgetPosition();
$(window).on('resize', debounce(followAndShareWidgetPosition, 250));